import React from 'react';
import { Image } from '@chakra-ui/react';
import logo from './vulcan-logo.png';

const Logo = (props) => <Image src={logo} {...props} w={120} />;

export default Logo;
